import { createAction, props } from '@ngrx/store';

import { AvailableOffersResponse } from '../../models/subscriber.model';

export const loadAvailableOffers = createAction(
  '[Available Offers] Load Available Offers',
  props<{ cnpj: string }>()
);

export const loadAvailableOffersSuccess = createAction(
  '[Available Offers] Load Available Offers Success',
  props<{ response: AvailableOffersResponse }>()
);

export const loadAvailableOffersFailure = createAction(
  '[Available Offers] Load Available Offers Failure',
  props<{ error: string }>()
);

export const clearAvailableOffers = createAction(
  '[Available Offers] Clear Available Offers'
);

// Action para mapear offers para variations
export const mapOffersToVariations = createAction(
  '[Available Offers] Map Offers To Variations',
  props<{ offerToVariationMap: Record<string, string[]> }>()
);

